import { TIRED_PRICING } from '../../utils/permissions'
export default [
  {
    path: '/settings/tiered-pricing/add',
    name: 'tired-pricing-add',
    component: () => import('@/views/pricing-group/AddTieredPricingGroup.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Tiered Pricing Group',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Tiered Pricing Group', url: '/settings/tiered-pricing' },
        { title: 'Add Tiered Pricing Group', active: true }
      ],
      permissions: [TIRED_PRICING]
    }
  },
  {
    path: '/settings/tiered-pricing/:id/edit',
    name: 'tired-pricing-edit',
    component: () => import('@/views/pricing-group/EditTieredPricingGroup.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Tiered Pricing Group',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Tiered Pricing Group', url: '/settings/tiered-pricing' },
        { title: 'Edit Tiered Pricing Group', active: true }
      ],
      permissions: [TIRED_PRICING]
    }
  },
  {
    path: '/settings/tiered-pricing',
    name: 'tired-pricing-list',
    component: () => import('@/views/pricing-group/TieredPricingGroupList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Tiered Pricing Group',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Tiered Pricing Group' }, { title: 'Tiered Pricing Group List', active: true }],
      permissions: [TIRED_PRICING]
    }
  }
]
